(function () {
    'use strict';

    angular.module("imApp").factory("travExpTypesService", ['$ihttp', function ($ihttp) {
        let service = {
            getTravelExpenseTypes: function (parms) {
                return $ihttp.post({
                    method: 1268,
                    parameters: parms || {}
                });
            },
            listTravelExpenseTypes: function (parms) {
                return $ihttp.post({
                    method: 1267,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
